// extracted by mini-css-extract-plugin
export default {"threedotsBtn":"style_threedotsBtn__UgPQI","packagesTable":"style_packagesTable__z2gCF","actionColumn":"style_actionColumn__qrg4J"};